import fetch from "@/utils/request";


export default {
  getHelpTopLists(data?: object): any {
    return fetch({
      url: "/php/api/help/top/lists",
      method: "get",
      data
    });
  },
  getHelpCategoryTree(data?: object): any {
    return fetch({
      url: "/php/api/help/category/tree",
      method: "get",
      data
    });
  },
}
